import { render, staticRenderFns } from "./tenant_menu_action__list.vue?vue&type=template&id=47ee5639"
import script from "./tenant_menu_action__list.vue?vue&type=script&lang=js"
export * from "./tenant_menu_action__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports